import { ClarityType } from '../clarityValue';
function noneCV() {
    return { type: ClarityType.OptionalNone };
}
function someCV(value) {
    return { type: ClarityType.OptionalSome, value };
}
function optionalCVOf(value) {
    if (value) {
        return someCV(value);
    }
    else {
        return noneCV();
    }
}
export { noneCV, someCV, optionalCVOf };
//# sourceMappingURL=optionalCV.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect/node_modules/@stacks/transactions/dist/esm/clarity/types/optionalCV.js
// module id = null
// module chunks = 